import { useEffect, useState } from "react";
import { getFaqs } from "@/services/faq.service";
import { localizeField } from "@/utils/i18nBackend";

export function useFaqs(isAR = false) {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function fetchFaqs() {
      try {
        setLoading(true);
        setError(null);

        const result = await getFaqs();

        const formattedFaqs = result.data.map((item) => ({
          id: item.id,
          question: localizeField(item, "question"),
          answer: localizeField(item, "answer"),
        }));

        if (active) {
          setFaqs(formattedFaqs);
        }
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "Failed to load FAQs"
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    fetchFaqs();

    return () => {
      active = false;
    };
  }, [isAR]);

  return {
    faqs,
    loading,
    error,
  };
}